<template>
  <div>
    <!-- 发表最新动态 -->
    <div class="fabiaodongtai">
      <div class="dongtai">
        <div
          class="message"
          contentEditable="true"
          @click="isShare"
          placeholder="今天想说点什么呢?"
        ></div>
        <i class="iconfont iconxiangji" @click="picload"></i>
      </div>

      <!-- 分享范围区域 -->
      <div
        class="queding"
        @click="queding"
        :style="isshare === false ? 'display:none' : 'display:block'"
      >
        发表
      </div>
      <!-- 表情包 -->
      <div
        class="biaoqing"
        :style="isshare === false ? 'display:none' : 'display:block'"
      >
        <img src="@/assets/biaoqing.png" @click="xianshi" />
      </div>
      <a
        href="javascript:;"
        :style="isshare === false ? 'display:none' : 'display:block'"
        @click="whereShare"
      >
        分享范围 :
        <span v-for="show in this.list" :key="show.space_name"
          >{{ show.space_name }}&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span v-if="this.list == ''">{{ this.listname.space_name }}</span>
        <i class="el-icon-arrow-right"></i>
      </a>
    </div>
    <div v-show="isshow" style="margin-top: 5px">
      <el-upload
        accept="image/png,image/gif,image/jpeg,image/bmp/"
        action="https://jsonplaceholder.typicode.com/posts/"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :before-upload="beforeUpload"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
    <!-- 点击刷新按钮 -->
    <div class="refresh">
      <span @click="start">
        <div
          style="display: inline-block"
          RenderTransformOrigin="0.5,0.5"
          :class="[rotate ? 'go' : 'aa']"
        >
          <i class="iconfont iconshuaxin"></i>
        </div>
        <span>刷新动态</span>
        <!-- <img :class="[rotate?'go':'aa']" src="@/assets/image/sw1.png" alt=""> -->
      </span>
    </div>

    <!-- 点击发分享范围态生成的对话框 -->
    <el-dialog title="分享至" :visible.sync="shareDialogVisible" width="30%">
      <span>
        <el-checkbox-group
          v-model="checkedCities"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox v-for="item in cities" :label="item" :key="item.id">{{
            item.space_name
          }}</el-checkbox>
        </el-checkbox-group>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show(1)">取 消</el-button>
        <el-button type="primary" @click="show(2)">确 定</el-button>
      </span>
    </el-dialog>
    <el-button :plain="true" @click="open" style="display: none"></el-button>
  </div>
</template>

<script>
import $ from "jquery";
import URL from "../../api/index";
import VueEvent from "../../api/eventBus";
// import { log } from 'util';
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      model:'',
      isshare: false,
      // 是否展示对话框
      shareDialogVisible: false,
      UserInfo: "",
      getSpaceinfo: "",
      text: "",
      rotate: false,
      checkedCities: [],
      cities: "",
      isshow: false,
      dialogImageUrl: "",
      dialogVisible: false,
      dy_pic: { pic: [] },
      quedingone: "",
      list: "",
      listname: "",
    };
  },
  mounted() {
    if (this.$route.name == "dynamic") {
        this.model = "最新动态";
      }
      if (this.$route.name == "school") {
        this.model = "学校圈";
      }
      if (this.$route.name == "glass") {
        this.model = "班级圈";
      }
      if (this.$route.name == "saying") {
        this.model = "说说";
      }
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    this.userspace();
    this.getOssToken();
  },
  methods: {
    //数据上报
    getRecordRjw(hh, model) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_publish",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的发表功能",
          data: {
            function: model,
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            content: this.text,
            sharingscope: this.checkedCities,
            pictureaddress: this.dy_pic.pic,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //获取上传通行证
    getOssToken() {
      var _self = this;
      this.$get(
        "https://api.rujiaowang.net/netlearn/Common/album_get_oss_key"
      ).then(function (res) {
        _self.aliyunOssToken = res;
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeUpload(file) {
      // console.log(file.type);
      if (
        file.type === "image/jpeg" ||
        file.type === "image/gif" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "video/mp4" ||
        file.type === "video/webm" ||
        (file.type === "" && file.size / 1024 / 1024 < 2)
      ) {
        var filename = file.name;
        // var uploadname = file.name;
        var getSuffix = function (filename) {
          var pos = filename.lastIndexOf(".");
          var suffix = "";
          if (pos != -1) {
            suffix = filename.substring(pos);
          }
          return suffix;
        };
        filename =
          new Date().getTime() +
          Math.ceil(Math.random() * 10000) +
          getSuffix(filename);
        // console.log(filename);
        var _self = this;
        var formData = new FormData();
        //注意formData里append添加的键的大小写
        formData.append(
          "key",
          _self.aliyunOssToken.dir + "space/dynamic" + filename
        ); //存储在oss的文件路径
        formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid); //accessKeyId
        formData.append("policy", _self.aliyunOssToken.policy); //policy
        formData.append("Signature", _self.aliyunOssToken.signature); //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
        formData.append("callback", _self.aliyunOssToken.callback); //policy
        formData.append("file", file);
        formData.append("success_action_status", 200); //成功后返回的操作码
        var url = _self.aliyunOssToken.host;
        var fileUrl =
          _self.aliyunOssToken.host +
          "/" +
          _self.aliyunOssToken.dir +
          file.name;
        var point = this;
        $.ajax({
          url: url,
          type: "POST",
          data: formData,
          // async: false,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            point.dy_pic["pic"].push(data.filename);
          },
          error: function (data) {},
        });
        this.$message({
          message: "上传成功",
          center: true,
        });
      } else {
        this.$message({
          message: "请上传正确的图片格式",
          center: true,
        });
        return false;
      }
    },
    picload() {
      this.isshow = this.isshow == true ? false : true;
    },
    userspace() {
      var that = this;
      var userspace_data = {
        token: that.UserInfo.token,
        user_id: that.UserInfo.user_id,
      }; // 下属空间列表
      this.$post(URL.userspace, userspace_data).then((res) => {
        var cityOptions = res.result;
        that.cities = cityOptions;
        for (var i = 0; i < that.cities.length; i++) {
          if (that.cities[i].space_id == that.getSpaceinfo.space_id) {
            that.checkedCities.push(that.cities[i]);
            this.listname = that.cities[i];
          }
        }
      });
      //接受传过来的表情
      VueEvent.$off("expression");
      VueEvent.$on("expression", function (data) {
        var spanelement = data;
        var clonefalse = spanelement.cloneNode(false);
        that.expression(clonefalse);
      });
    },
    //div添加表情
    expression: function (e) {
      $(".message").append(e);
    },
    handleCheckedCitiesChange(e) {
      // console.log(e);
      this.checkedCities = e;
      this.list = e;
    },
    // 点击文本框显示分享栏
    isShare() {
      this.isshare = true;
    },
    // 点击分享范围（展示对话框）
    whereShare() {
      this.shareDialogVisible = true;
    },
    queding() {
      var str = $(".message").html();
      //   log(str)  //获取复制进来的内容
      var re = /<(?!\/?br\/?.+?>|\/?img.+?>)[^<>]*>/gi; //清空标签的正则
      str = str.replace(re, "");
      this.text = str; //替换成没有样式的内容
      if (this.text == "" || this.text == undefined) {
        this.open();
      } else {
        this.quedingone = true;
        this.show(2, this.text);
        this.userspace();
        this.quedingone = "";
      }
    },
    show(e) {
      var that = this;
      if (e == 1) {
        that.shareDialogVisible = false;
      } else if (e == 2) {
        this.checkedCities.forEach(function (e) {
          if (that.quedingone == true) {
            that.addfabiao(e.space_id);
          }
        });
        that.shareDialogVisible = false;
      }
      if (that.quedingone == true) {
        $(".message").empty();
      }
    },
    //  发表动态
    addfabiao(e) {
      this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")), this.model);
      var that = this;
      var createDynamic_data = {
        token: that.UserInfo.token,
        dynamic_content: that.text,
        dynamic_wmm: JSON.stringify(that.dy_pic),
        dynamic_forward: "",
        dynamic_from_app: "",
        space_id: e,
      };
      //  发表动态
      this.$post(URL.createDynamic, createDynamic_data).then((res) => {
        that.$emit("renoav", "787878787");
        this.text = "";
      });
    },
    start() {
      this.getRjwNew(JSON.parse(localStorage.getItem("loginInfo")), this.model)
      this.rotate = !this.rotate;
      this.$emit("renoav", "787878787");
    },
    //刷新-数据上报
    getRjwNew(hh, model) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_refresh",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的刷新动态功能",
          data: {
            function: model,
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    open() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [h("span", null, "请输入内容")]),
      });
    },
    xianshi() {
      this.$emit("renoav", true);
    },
  },
};
</script>

<style lang="less" scoped>
.fabiaodongtai {
  box-sizing: border-box;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(15, 26, 47, 0.06);
  border-radius: 4px;
  color: #898989;
  position: relative;
  overflow: hidden;
  .dongtai {
    height: 70px;
    border-bottom: 1px solid #efefef;
    overflow: hidden;
    textarea {
      text-indent: 2rem;
      width: 100%;
      height: 100%;
      border: 0;
      float: left;
      outline: none;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      resize: none;
    }
    i {
      float: right;
      font-size: 30px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
  }
  .biaoqing {
    float: left;
    margin-left: 20px;
    position: relative;
    img {
      margin-top: 9px;
    }
  }
  a {
    float: left;
    line-height: 40px;
    font-size: 14px;
    color: #2c84ff;
    margin-left: 20px;
  }
  .queding {
    font-size: 14px;
    color: #f2f2f2;
    background-color: #409eff;
    border: 1px solid #1ca5fc;
    float: right;
    margin-right: 20px;
    margin-top: 5px;
    height: 30px;
    line-height: 30px;
    width: 4em;
    text-align: center;
    cursor: pointer;
    border-radius: 5px;
  }
  .queding:hover {
    opacity: 0.9;
  }
}
.refresh {
  width: 100%;
  height: 53px;
  line-height: 53px;
  position: relative;
  span {
    cursor: pointer;
    float: right;
    color: #3c495c;
    font-size: 14px;
    i {
      vertical-align: middle;
    }
    span {
      margin-left: 5px;
    }
  }
}
.aa {
  transition: all 1s;
}

.go {
  transform: rotate(-360deg);
  transition: all 1s;
}
.el-checkbox {
  line-height: 40px;
}
.message {
  height: 100%;
  padding: 0 1em;
  border: none;
  overflow-y: auto;
}
.message:focus {
  border: none;
  outline: none;
}
/*为空时显示 element attribute content*/
.message:empty:before {
  content: attr(placeholder);
  padding-left: 10px;
  line-height: 70px;
}
/*焦点时内容为空*/
.message:focus:before {
  content: none;
}
</style>
